import React from 'react'
import NextImage from 'next/image'
import { css } from '@emotion/react'

// const imageLoader = ({ src, width, quality }) => {
//     return `https://example.com${src}?w=${width}&q=${quality || 75}`
// }

function Image({ src, alt, width, height, layout = 'intrinsic', priority = false, objectFit = 'contain', style, noStyle = false, ...others }) {
    const r = <NextImage
        src={src}
        alt={alt}
        width={width}
        height={height}
        priority={priority}
        layout={layout}
        objectFit={objectFit}
        // loader={imageLoader}
        style={(noStyle && typeof style !== 'string') ? style : null}
        {...others} />

    return noStyle ? r : (
        <div className="image" css={css`${style}`}>
            {r}
        </div>
    )
}

export default Image